import { Facet } from '@finder/shared/services/filter-emitter-service/facet.class';

export class HeightFacet extends Facet {

    height: string;

    constructor(
        public id: string,
        public label: string,
        public value = false,
        height: string,
        group = 'height'
    ) {
        super(id, label, value, group);
        this.height = height;
    }
}
